export default __webpack_public_path__ + "static/media/2.68fea097.jpeg";